import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addTeam,
  getTeams,
  getTeam,
  editTeam,
  deleteTeam,
  getAllTeams,
} from "../../store/actions/team_action";
import { SEARCH_TERMS } from "../enums/teams_enum";
// Get All Data
export const useAllTeams = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.team);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteTeam(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getTeams({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getTeams({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getTeams({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleTeam = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.team);
  useEffect(() => {
    dispatch(getTeam(id));
  }, [id]);
  return [data];
};
// Get Single Data
export const useSelectAllTeams = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.team);
  useEffect(() => {
    dispatch(getAllTeams());
  }, []);
  return [data];
};
// Add Data
export const useCreateTeam = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addTeam(data));
  };
  return [addData];
};
export const useUpdateTeam = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editTeam(id, data));
  };
  return [updateData];
};
